import { Colors } from "../helpers/Colors";
import { fontSize } from "../helpers/fontSize";
import { makeStyles } from "@mui/styles";

export const Confirm_Modal_useStyles = makeStyles({
  DetailsCon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    // backgroundColor: Colors.tom,
  },
  Cabin_Date: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexDirection: "row",
    // backgroundColor: Colors.tyke,
    width: "530px",
    "& .Cabin": {
      // backgroundColor: Colors.tom,
      display: "flex",
      alignItems: "flex-start",
      justifyContent: "space-between",
      flexDirection: "column",
      width: "250px",
      padding: "0 0 8px 0",
      "& label": {
        fontSize: fontSize.label,
        color: Colors.secondary,
        fontWeight: 500,
        margin: "0px",
        padding: "0px",
      },
      "& input": {
        width: "100%",
        padding: "5px 10px",
        color: Colors.secondary,
        // fontWeight: 400,
        fontSize: fontSize.reservationDetails,
        borderRadius: "5px",
        border: `1px solid ${Colors.primary}`,
        backgroundColor: Colors.primaryExtraLight2,
        outline: "none",
      },
    },
  },
  Container_Six: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    width: "full",
    "& .Submit_Button": {
      width: "100%",
      fontWeight: 600,
      padding: "0px 0px 0px 0",
      "& button": {
        width: "100%",
        padding: "10px 10px",
        margin: "8px 0px 0 0 ",
        outline: "none",
        border: `2px solid ${Colors.primary}`,
        backgroundColor: Colors.primary,
        fontSize: "16px",
        borderRadius: "5px",
        color: Colors.secondary,
        "@media only screen and (max-Width: 770px) ": {},
      },
    },
  },
});
